export class BaseOptions {
  pageSize: number;

  pageIndex: number;

  sortCol: string;

  sortDir: string;

  filter?: string;

  constructor() {
    this.pageIndex = 0;
    this.pageSize = 100;
    this.sortCol = 'id';
    this.sortDir = 'desc';
  }
}
